import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplyComponent } from './components/apply/apply.component';
import { ApplyHomeComponent } from './components/apply-home/apply-home.component';
import { IdCardComponent } from './components/id-card/id-card.component';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { ImageModule } from '../../shared/image/image.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PerfectScrollbarModule,
    ImageModule
  ],
  declarations: [
    ApplyComponent,
    ApplyHomeComponent,
    IdCardComponent
  ],
  exports: [
    ApplyComponent,
    ApplyHomeComponent,
    IdCardComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class ApplyModule { }
